import type { Schema } from "yup";

export function safeCast(schema: Schema, values: any) {
  try {
    return schema.cast(values);
  } catch {
    return values;
  }
}
